import { Fragment, useState, useEffect } from 'react';

import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';

import { useForm, useFormState } from 'react-final-form';

import { FormWithMutators } from '~/components/common/form/formWithMutators';
import { RankedDateFormFields } from '~/components/common/form/WeddingDateField/types';

import { WeddingDateField } from '../WeddingDateField/WeddingDateField';

import styles from './rankedDateSelection.module.less';

export const RankedDateSelection = <FormValues extends RankedDateFormFields>({
  forceErrorsVisible = false,
}: {
  forceErrorsVisible?: boolean;
}): JSX.Element => {
  const form = useForm<FormValues>() as FormWithMutators<FormValues>;
  const { values } = useFormState<FormValues>();
  const { clear: clearField } = form.mutators;

  const [showSecondChoiceDateInput, setShowSecondChoiceDateInput] = useState(false);
  const [showThirdChoiceDateInput, setShowThirdChoiceDateInput] = useState(false);
  useEffect(() => {
    if (values.expandedWeddingDateSecondChoice) {
      setShowSecondChoiceDateInput(true);
    }
    if (values.expandedWeddingDateThirdChoice) {
      setShowThirdChoiceDateInput(true);
    }
    // Run once on component load, after that, changes are managed by the fields
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showBackupDateInput = () => {
    if (!showSecondChoiceDateInput) {
      setShowSecondChoiceDateInput(true);
    } else {
      setShowThirdChoiceDateInput(true);
    }
  };
  return (
    <div className={styles.rankedDateWrapper}>
      <div>
        <WeddingDateField
          label="First choice"
          field="expandedWeddingDateFirstChoice"
          forceErrorsVisible={forceErrorsVisible}
        />
        {showSecondChoiceDateInput && (
          <Fragment>
            <WeddingDateField
              label="Alternate"
              field="expandedWeddingDateSecondChoice"
              removeField={() => {
                setShowSecondChoiceDateInput(false);
                clearField('expandedWeddingDateSecondChoice');
              }}
              forceErrorsVisible={forceErrorsVisible}
            />
          </Fragment>
        )}
        {showThirdChoiceDateInput && (
          <WeddingDateField
            label="Alternate"
            removeField={() => {
              setShowThirdChoiceDateInput(false);
              clearField('expandedWeddingDateThirdChoice');
            }}
            field="expandedWeddingDateThirdChoice"
            forceErrorsVisible={forceErrorsVisible}
          />
        )}
      </div>
      {!showThirdChoiceDateInput && (
        <LinkV2
          onClick={showBackupDateInput}
          className={styles.btn}
          role="button"
          type="button"
          variant="primary"
        >
          + Add another
        </LinkV2>
      )}
    </div>
  );
};
